import React, { useEffect } from 'react';
import styles from '../styles/Q4EBenefits.module.scss';
import Spinner from 'components/spinner';
import { INSURANCE_TYPES_ICONS_SVG_V2 } from 'constants/insurance';
import { getEmployerPolicies, limitNumber, prettifyNumber } from 'helpers';
import PartnerOffers from './PartnerOffers';
import { CheckCircle } from 'components/icons';
import { getEmployerPolicyGrouped } from 'containers/policy-details/utils';
import { INSURANCE_TYPES_NAMES } from 'constants/insurance-types-names';

const getBenefits = (policies, employer) => {
  const employerPolicies = getEmployerPolicies(policies, employer);
  return employerPolicies.reduce((acc, p) => {
    if (p.policyType === INSURANCE_TYPES_NAMES.LIFE) {
      p.insured.forEach((ins) => {
        ins.additionalCovers.forEach((ac) => {
          acc.push({
            amount: ac.insuredAmount,
            frequency: ac.payoutFrequency?.toLowerCase().replace('ly', ''),
            policyType: ac.policyType,
          });
        });
      });
    } else {
      acc.push({
        amount: p.amount,
        frequency: p.payoutFrequency?.toLowerCase().replace('ly', ''),
        policyType: p.policyType,
      });
    }
    return acc;
  }, []);
};

const Q4EBenefits = ({
  employer,
  policies,
  loading,
  employers,
  user,
  setEdit,
  submitEmployer,
}) => {
  const benefits = getBenefits(policies, employer);
  const offers = employer?.offers;
  const provider = employers.find(R.propEq('id', user.employerId));
  const employerPolicies = getEmployerPolicyGrouped(employer?.policies, user);

  useEffect(() => {
    // Set to edit mode when user has no benefits
    // ie. They haven't finished the flow
    if (
      !loading &&
      !employer?.offers &&
      employer?.policies?.length > 0 &&
      benefits?.length === 0
    ) {
      setEdit(true);
    }
  }, [loading]);

  if (loading) {
    return (
      <div className={styles.container}>
        <Spinner className={styles.spinner} loading={true} />
      </div>
    );
  }

  if (user.otherEmployerName) {
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <CheckCircle />
          <div className={styles.otherEmployerName}>
            {user.otherEmployerName}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <img alt={provider?.name} src={provider?.employerLogoUrl} />
        <b>{provider?.name}</b>
      </div>
      {offers ? (
        <PartnerOffers
          employer={employer}
          offers={offers}
          submitEmployer={submitEmployer}
        />
      ) : (
        <>
          {benefits.map(({ amount, frequency, policyType }, idx) => {
            const Icon = INSURANCE_TYPES_ICONS_SVG_V2[policyType];
            const benefitDisclaimer = employerPolicies[policyType]?.disclaimer;
            const limit = employerPolicies[policyType]?.limit;
            const value = limitNumber(amount, limit);

            return (
              <div key={`benefit_${idx}`} className={styles.benefit}>
                <div className={styles.policyType}>
                  <Icon />
                  <b>{policyType}</b>
                </div>
                <div className={styles.value}>
                  ${prettifyNumber(value)}
                  {frequency ? `/${frequency}` : ''}
                </div>
                {!!benefitDisclaimer && (
                  <div className={styles.value}>{benefitDisclaimer}</div>
                )}
              </div>
            );
          })}
        </>
      )}
    </div>
  );
};

export default Q4EBenefits;
